export const HERO_ENDPOINT = () => `/header`;
export const HERO_PREVIEW_ENDPOINT = (countryId) => `/hero/${countryId}/preview`;
export const FAMILY_ENDPOINT = () => `/family`;
export const BLOG_ENDPOINT = () => `/blog`;
export const BLOG_CATEGORIES_ENDPOINT = () => `/blog/categories`;
export const FOOTER_ENDPOINT = () => `/footer`;
export const TEAM_ENDPOINT = () => `/team`;
export const TESTIMONIAL_ENDPOINT = () => `/testimonial`;
export const CONTACT_ENDPOINT = (countryId) => `/contact/${countryId}`;
//export const TRANSLATION_ENDPOINT = (lang) => `/translation/${lang}`;
export const TRANSLATION_ENDPOINT = (countryId, env) => `https://d7n4bh3bohn60.cloudfront.net/assets/${countryId}/text_content/${env}/content.js`;
export const TRANSLATION_GLOBAL_ENDPOINT = (countryId, env, lang) => `https://d7n4bh3bohn60.cloudfront.net/assets/${countryId}/text_content/${env}/${lang}/content.js`;
export const LOCAL_PRODUCTS_ENDPOINT = () => `/localProduct`;
export const LOCAL_PRODUCT_ENDPOINT = (productId) => `/localProduct/product/${productId}`;
export const LOCAL_PRODUCT_BY_NAME_ENDPOINT = (countryCode, productName) => `/localProduct/product-by-name/${countryCode}/${encodeURIComponent(productName)}`;
export const LOCAL_PRODUCTS_FILTERS_CROPS_ENDPOINT = () => `/localProduct/crops`;
export const LOCAL_PRODUCTS_FILTERS_COMPOSITION_ENDPOINT = () => `/localProduct/compositions`;
export const LOCAL_PRODUCTS_FILTERS_PROBLEMATICS_ENDPOINT = () => `/localProduct/benefits`;
export const LOCAL_PRODUCTS_FILTERS_TYPES_ENDPOINT = () => `/localProduct/types`;
export const LOCAL_PRODUCTS_FILTERS_FAMILIES_ENDPOINT = () => `/localProduct/families`;
export const LOCAL_PRODUCTS_DISCLAIMER_ENDPOINT = () => `/localProduct/disclaimer`;
export const COUNTRY = () => `https://d7n4bh3bohn60.cloudfront.net/assets/countries.json?t=${Date.now()}`;
export const COUNTRY_ZHO = () => `https://d7n4bh3bohn60.cloudfront.net/assets/countries_zho.json?t=${Date.now()}`;
export const PRODUCT_B2B_ENDPOINT = (countryId) => `/productB2B/${countryId}`;
export const PRODUCT_GLOBAL_ENDPOINT = () => `/productGlobal`;
export const PORTFOLIO_ENDPOINT = () => `/webPortfolio`;
export const PLANT_ENDPOINT = () => `/webPlant`;
export const ENVIRO_ENDPOINT = () => `/webenviro`;
export const INFO_DISCLOSURE_ENDPOINT = () => `/infoDisclosure`;
export const REPORT_GROUPS_ENDPOINT = () => `/report/categories`;
export const REPORTS_BY_GROUP_ENDPOINT = (groupId) => `/report?category=${groupId}`;
export const TIMELINE_ENDPOINT = () => `/timeline`;
export const WEB_COMPANY_PLATFORM_ENDPOINT = () => `/companyPlatform`;
export const COUNTRY_REGION_ENDPOINT = (countryId) => `/country/regions/${countryId}`;

export const LOCAL_REPORT_GROUPS_ENDPOINT = () => `/localReport/categories`;
export const LOCAL_REPORTS_BY_GROUP_ENDPOINT = (groupId) => `/localReport?category=${groupId}`;

export const DOCUMENT_ZIP_ENDPOINT = (productLocalId, fileId) =>
  `/localProduct/${productLocalId}/files/${fileId}/download-zip`;